export default {
  hoursAgo: 'u geleden'
};
